import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "active-arrow",
  "use": "active-arrow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"active-arrow\">\n<g id=\"active-arrow_arrow / drop_left\">\n<path id=\"active-arrow_Vector1\" d=\"M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z\" fill=\"#484848\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol